export default __webpack_public_path__ + "static/media/colaboradores.fabaca68.png";